import { IInmate } from '../models/Inmate';

export const SET_INMATE = 'POST_OFFICE/SET_INMATE';

export interface ISetInmateAction {
  type: typeof SET_INMATE;
  inmate: IInmate;
}

export type PostOfficeActionTypes = ISetInmateAction;

export function setInmate(inmate: IInmate): ISetInmateAction {
  return {
    type: SET_INMATE,
    inmate
  };
}